module.exports = __webpack_public_path__ + "static/img/leftDataOn.9feabe17.png";